'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _Total = require('./Total.jsx');

var _Total2 = _interopRequireDefault(_Total);

var _TotalSplit = require('./TotalSplit.jsx');

var _TotalSplit2 = _interopRequireDefault(_TotalSplit);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Pricing(props) {
  var faresBreakDown = props.faresBreakDown,
      optionPrice = props.optionPrice;


  return _react2.default.createElement(
    'table',
    { style: { borderCollapse: 'collapse', width: '100%' }, 'data-component': 'Pricing' },
    _react2.default.createElement(
      'tbody',
      null,
      faresBreakDown && _react2.default.createElement(
        'tr',
        null,
        _react2.default.createElement(
          'td',
          { style: { padding: '0' } },
          _react2.default.createElement(_TotalSplit2.default, { faresBreakDown: faresBreakDown })
        )
      ),
      _react2.default.createElement(
        'tr',
        null,
        _react2.default.createElement(
          'td',
          { style: { padding: '0' } },
          _react2.default.createElement(_Total2.default, { optionPrice: optionPrice })
        )
      )
    )
  );
}

var mstp = function mstp(state) {
  return {
    components: state.templateApplication.templates.currentTemplate.components
  };
};

exports.default = (0, _reactRedux.connect)(mstp)(Pricing);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/TemplateComponents/Air/Email/Pricing.jsx
// module id = 1481
// module chunks = 0